import api from '../api';

const videoCallService = {
    // List all meetings for the authenticated user
    list: (params) => api.get('/video/meetings', { params }),

    // Get meetings for calendar view (by month)
    calendar: (month) => api.get('/video/meetings/calendar', { params: { month } }),

    // Create an instant meeting
    createInstant: (payload) => api.post('/video/meetings/instant', payload),

    // Schedule a meeting
    schedule: (payload) => api.post('/video/meetings/schedule', payload),

    // Get meeting details
    show: (id) => api.get(`/video/meetings/${id}`),

    // Join a meeting (get tokens)
    join: (id) => api.post(`/video/meetings/${id}/join`),

    // Reject a meeting invitation
    reject: (id) => api.post(`/video/meetings/${id}/reject`),

    // Leave a meeting
    leave: (id) => api.post(`/video/meetings/${id}/leave`),

    // Update meeting
    update: (id, payload) => api.put(`/video/meetings/${id}`, payload),

    // Cancel (delete) meeting
    cancel: (id) => api.delete(`/video/meetings/${id}`),

    // Generate and return a shareable guest invite link (host only)
    copyInviteLink: (id) => api.post(`/video/meetings/${id}/invite-link`),

    // Add members to an ongoing meeting
    addMembers: (id, invitees) => api.post(`/video/meetings/${id}/members`, { invitees }),

    // Public: get meeting info for a guest token (no auth)
    getGuestMeeting: (token) => api.get(`/public/video-invites/${token}`),

    // Public: join a meeting as a guest (no auth)
    joinAsGuest: (token, name) => api.post(`/public/video-invites/${token}/join`, { name }),

    // Get call history for a specific Talk conversation (includes transcription)
    getCallHistory: (conversationId) =>
        api.get('/video/meetings', { params: { conversation_id: conversationId } }),
};

export default videoCallService;
